import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const Header = styled.header`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`;

export const Title = styled.h3`
    ${Fonts.Heading.H400}
    margin-bottom: 2px;
    color: ${Colors.Black.V100};
`;

export const Container = styled.section`
    header {
        margin-bottom: 16px;
    }
`;

export const SubTitle = styled.p`
    ${Fonts.Heading.H600}
    color: ${Colors.Gray.V300};
`;

export const childFirst = css`
    margin-top: 22px;
    margin-bottom: 38px;
`;

export const TagsContainer = styled.div`
    margin-bottom: ${Spacing.LG}px;
`;

export const tag = css`
    &:not(:last-child) {
        margin-right: ${Spacing.SM}px;
    }
`;

export const tagSelected = css`
    background-color: ${Colors.Yellow.V200};
`;

export const tagDisabled = css`
    cursor: auto;
`;
